"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Popover = _interopRequireDefault(require("./Popover"));

var _underscore = _interopRequireDefault(require("underscore"));

var _popsOver = _interopRequireDefault(require("../../util/behaviors/popsOver"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var PopoverBase = _Popover.default.Base;
/**
 * @typedef {object} PopoverMenu.Button
 * @property {string} key
 *      When provided, becomes the key for the button element.
 * @property {node|string} label
 *      The label of the button
 * @property {function} onClick
 *      Click event for the button
 * */

/**
 * @class PopoverMenu
 * @desc Menu of buttons that appears in a popover.
 *
 * @param {string} [data-id="popover-menu"]
 *     To define the base "data-id" value for top-level HTML container.
 * @param {string} [className]
 *     CSS classes to set on the top-level HTML container.
 * @param {Array.<PopoverMenu.Button>} [buttons]
 *     Objects that define the buttons. Accepts "label", "onClick", and "id".
 * @param {string} [triggerClassName]
 *     CSS classes to set on the link that triggers the popover.
 *
 * @param {object|string} [label]
 *     A string or JSX object that serves as the trigger label.
 *
 * @param {string} [placement]
 *     Placement using keywords top, left, right. (Default is bottom center)
 *
 * @param {boolean} [open=false]
 *     If true, tooltip is open or else closed.
 * @param {function} [onToggle]
 *     Callback to be triggered when trigger is clicked.
 */

var PopoverMenuBase = /*#__PURE__*/function (_PopoverBase) {
  (0, _inherits2.default)(PopoverMenuBase, _PopoverBase);

  var _super = _createSuper(PopoverMenuBase);

  function PopoverMenuBase() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, PopoverMenuBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getDataId", function (id, label, index) {
      if (id !== undefined) {
        return id;
      }

      return _underscore.default.isString(label) ? label.toLowerCase().replace(/[^0-9a-z]/gi, "") : index;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderItem", function (item, handleClick, index) {
      var _context2;

      return /*#__PURE__*/_react.default.createElement("button", {
        "data-id": (0, _concat.default)(_context2 = "".concat(_this.props["data-id"], "-button-")).call(_context2, _this._getDataId(item.id, item.label, index)),
        key: item.id || item.label,
        className: "button-menu__button",
        onClick: handleClick
      }, item.label);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderContent", function () {
      return (0, _map.default)(_underscore.default).call(_underscore.default, _underscore.default.union(_this.props.items, _this.props.buttons), function (item, index) {
        var handleClick = function handleClick() {
          if (item.onClick) {
            item.onClick();
          }

          _this.props.onClose();
        };

        return _this.renderItem(item, handleClick, index);
      });
    });
    return _this;
  }

  return PopoverMenuBase;
}(PopoverBase);

(0, _defineProperty2.default)(PopoverMenuBase, "propTypes", _underscore.default.extend(PopoverBase.propTypes, {
  items: _propTypes.default.array,
  buttons: _propTypes.default.array
}));
(0, _defineProperty2.default)(PopoverMenuBase, "defaultProps", _underscore.default.extend(PopoverBase.defaultProps, {
  "data-id": "popover-menu",
  items: [],
  buttons: []
}));
var PopoverMenu = (0, _popsOver.default)(PopoverMenuBase);
PopoverMenu.Base = PopoverMenuBase;
module.exports = PopoverMenu;